import axios from "axios";
export const uploadResourceToAWS = async ({ resData, fileBuffer, fileType }) => {
    const { signedPutRequest, url } = resData;
    await axios.put(signedPutRequest, fileBuffer, {
        headers: {
            "Content-Type": fileType ? fileType.mime : "application/octet-stream",
            Accept: "*/*",
            "Content-Encoding": "base64",
        },
    });
    return url;
};
//# sourceMappingURL=uploadUtils.js.map